import Cookies from 'js-cookie'
import { COMMON } from '@/common'

const _getCookie = function (key) {
  return Cookies.get(key)
}

const _setCookie = function (key, value) {
  return Cookies.set(key, value)
}

const _removeCookie = function (key) {
  return Cookies.remove(key)
}

export function getToken (extra) {
  return _getCookie(COMMON.COOKIES_TOKEN_KEY + extra)
}

export function setToken (token, extra) {
  return _setCookie(COMMON.COOKIES_TOKEN_KEY + extra, token)
}

export function removeToken (extra) {
  return _removeCookie(COMMON.COOKIES_TOKEN_KEY + extra)
}

export function getCookie (key) {
  return _getCookie(key)
}

export function setCookie (key, value) {
  return _setCookie(key, value)
}

export function removeCookie (key) {
  return _removeCookie(key)
}
